import CustomModal from "../../../../../components/Modal/CustomModal";
import DivContainerBody from "../../../../../components/DivContainerBody";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {GeneralCommentRequestModalApp} from "../Functionality/GeneralCommentRequestModalApp";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const GeneralCommentRequestModal  = (props) => {

    const {onHide, title, setModified, modified,row,status, module,endPoint} = props

    const {
        resetValues,
        emptyFields,
        handleChange,
        t,
        handleCreate,
        data,
        infoParagraph
    } = GeneralCommentRequestModalApp({onHide,setModified, modified,row ,status,module,endPoint})


    return (
        <CustomModal
            {...props}
            title={t(title)}
            size='md'
            onConfirm={() => {
                handleCreate(status)
            }}
            onHide={() => {
                onHide();
                resetValues();
            }}
        >
            <DivContainerBody>
                <div className={"d-flex flex-column justify-content-center gap-2 align-items-center"}>
                    <p className={"ibl-ientry-p ibl-font-w-400"}>{t('are_you_sure_to_proceed')}</p>
                    <p className={"ibl-ientry-p ibl-font-w-600 text-uppercase"}>{t(infoParagraph)}</p>
                </div>
                <div className={"mt-3"}>
                    <CustomTextField
                        length={512}
                        id='txt_gcm_reason'
                        name={'statusReason'}
                        value={data?.statusReason}
                        trans='comment'
                        emptyFields={emptyFields}
                        required={status !== STATUS_MODEL.APPROVED}
                        onChange={handleChange}
                        multiline={true}
                        row={4}
                    />
                </div>
            </DivContainerBody>
        </CustomModal>
    );
};
export default GeneralCommentRequestModal
